import { useEffect, useState } from 'react';
import { Lotus } from './ui/Lotus';

/**
 * Splash — a brief branded intro: a blank espresso screen with the logo, which
 * then "opens" (two panels slide apart) to reveal the site. Shows once per
 * browser session so it doesn't repeat on every internal navigation.
 */
export function Splash() {
  const [show, setShow] = useState(() => {
    try {
      return !sessionStorage.getItem('gh_splash_seen');
    } catch {
      return true;
    }
  });
  const [revealing, setRevealing] = useState(false);

  useEffect(() => {
    if (!show) return;
    try { sessionStorage.setItem('gh_splash_seen', '1'); } catch { /* ignore */ }
    document.body.style.overflow = 'hidden';
    const t1 = window.setTimeout(() => setRevealing(true), 1300);
    const t2 = window.setTimeout(() => {
      setShow(false);
      document.body.style.overflow = '';
    }, 2250);
    return () => {
      window.clearTimeout(t1);
      window.clearTimeout(t2);
      document.body.style.overflow = '';
    };
  }, [show]);

  if (!show) return null;

  const ease = 'cubic-bezier(0.76, 0, 0.24, 1)';

  return (
    <div className="pointer-events-none fixed inset-0 z-[100] overflow-hidden" aria-hidden>
      {/* Top panel */}
      <div
        className="absolute inset-x-0 top-0 h-[52%] bg-espresso-deep"
        style={{ transition: `transform 900ms ${ease}`, transform: revealing ? 'translateY(-100%)' : 'translateY(0)' }}
      />
      {/* Bottom panel */}
      <div
        className="absolute inset-x-0 bottom-0 h-[52%] bg-espresso-deep"
        style={{ transition: `transform 900ms ${ease}`, transform: revealing ? 'translateY(100%)' : 'translateY(0)' }}
      />
      {/* Logo + wordmark */}
      <div
        className="absolute inset-0 flex flex-col items-center justify-center"
        style={{ transition: 'opacity 450ms ease, transform 450ms ease', opacity: revealing ? 0 : 1, transform: revealing ? 'scale(1.04)' : 'scale(1)' }}
      >
        <span className="gh-splash-logo">
          <Lotus size={62} className="text-gold" />
        </span>
        <span className="gh-splash-word mt-3 font-script text-5xl leading-none text-gold">Grace Haven</span>
        <span className="gh-splash-word mt-3 font-body text-[11px] uppercase tracking-[0.35em] text-cream/70">Comfort · Elegance · Relaxation</span>
      </div>
    </div>
  );
}
